import { render } from "./CustomLoader.vue?vue&type=template&id=a47aa150&scoped=true"
import script from "./CustomLoader.vue?vue&type=script&lang=js"
export * from "./CustomLoader.vue?vue&type=script&lang=js"

import "./CustomLoader.vue?vue&type=style&index=0&id=a47aa150&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a47aa150"]])

export default __exports__